import { supabase } from '@/lib/supabase';

export const ROLES = {
  rg_learner: '1001旋轉門學員',
  mentor_trainee: 'Mentor學員',
  mentor_certified: '通過Mentor認證',
  heb23_dealer: 'HEB23子場經銷商',
  heb23_learner: 'HEB23子場學員',
  heb1_practitioner: 'HEB1施炁者',
  heb1_recipient: 'HEB1受炁者',
} as const;
export type Role = keyof typeof ROLES;
export type EditableRole = Exclude<Role, 'heb1_practitioner' | 'heb1_recipient'>;
export const EDITABLE_ROLES: EditableRole[] = ['rg_learner', 'mentor_trainee', 'mentor_certified', 'heb23_dealer', 'heb23_learner'];
export const GROUPS = { rg: '1001旋轉門', mentor: 'Mentor', heb1: 'HEB1宇炁療育', heb23: 'HEB23子場' };
export const STATUS: Record<string, string> = { active: '啟用', pending: '待審核', suspended: '暫停', revoked: '已撤銷', terminated: '已終止', not_started: '尚未啟用', candidate: '培育中', mentor_review: 'Mentor覆核中', authorized: '已授權' };
export interface Membership { role: EditableRole; status: string; notes: string | null }
export interface Person {
  user_id: string; email: string | null; phone: string | null; display_name: string;
  created_at: string; email_confirmed_at: string | null; last_sign_in_at: string | null;
  membership_status: string; roles: Role[]; memberships: Membership[];
  practitioner_status: string | null;
}
export interface PeopleResult { rows: Person[]; total: number }
export interface PersonDetail {
  user_id: string; profile: Record<string, unknown>; onboarding: Record<string, unknown>;
  documents: { document_type: string; review_status: string; uploaded_at: string; expires_at: string | null }[];
  practitioner: Record<string, unknown>; history: { scope: string; new_status: string; reason: string; changed_at: string }[];
}
function fail(error: { message: string }): never {
  if (/ROLE_FORBIDDEN/.test(error.message)) throw new Error('僅總管理員可存取全站人員資料。');
  if (/PGRST202|Could not find the function/.test(error.message)) throw new Error('人員管理資料庫尚未更新，請先執行本次SQL遷移。');
  throw new Error(error.message);
}
export async function listPeople(search: string, group: string, role: string, offset: number, limit = 50): Promise<PeopleResult> {
  const { data, error } = await supabase.rpc('admin_list_people', { p_search: search, p_group: group, p_role: role, p_offset: offset, p_limit: limit });
  if (error) fail(error);
  return data as PeopleResult;
}
export async function getPerson(id: string): Promise<PersonDetail> {
  const { data, error } = await supabase.rpc('admin_get_person', { p_user_id: id });
  if (error) fail(error);
  return data as PersonDetail;
}
export async function saveMembership(id: string, role: EditableRole, status: string, reason: string): Promise<void> {
  const { error } = await supabase.rpc('admin_set_program_membership', { p_user_id: id, p_role: role, p_status: status, p_reason: reason });
  if (error) fail(error);
}
export function date(value: unknown): string {
  return typeof value === 'string' && value ? new Date(value).toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' }) : '—';
}
export function csvCell(value: unknown): string {
  const text = String(value ?? '');
  return '"' + (/^[\s]*[=+@-]/.test(text) ? "'" + text : text).replace(/"/g, '""') + '"';
}
